(function($){

	$(window).on('load', function(){
		$('.border-overlay').addClass('animate');
	});
	
})(jQuery);